<template>
  <div class="homePage06Box" :style="bg">
    <!-- 头部导航 -->
    <div class="t_bar">
      <!-- 白色logo -->
      <div class="t_placeholder">
        <!-- 白色/蓝色图标 -->
        <div class="t_icon t_icon_search01" @click="$emit('openSearch')"></div>
        <div class="t_menu pointer" @mouseenter="$emit('openMenu')">
          <div class="t_menuitem"></div>
          <div class="t_menuitem t_menuitem2"></div>
          <div class="t_menuitem"></div>
        </div>
      </div>
      <div alt="" class="t_logo t_logo02" />
      <div class="t_right">
        <div class="mN_lage pointer"></div>
        <div class="mN_lag pointer">
          <div class="text">CN</div>
        </div>
      </div>
    </div>


    <div class="content">

      <div class="t_title">
        <div class="t_titleText">{{ title }}</div>
        <!-- <div class="t_titleBorder"></div>
        <div class="t_titleEng">PROFESSIONAL</div> -->
      </div>

      <div class="iconList fadeInDown">
        <div class="icon" v-for="item in iconOptions" :key="item.id">
          <img :src="imgUrl + item.logo" alt="" />
        </div>
      </div>
      <div class="more" @click="$tools.blankPush('/cooperativePartner')">
        MORE+
      </div>

    </div>

    <!-- <div class="loppBox">
      <div id="lopp" class="lopp1">
        <div class="border"></div>
        <div class="ball ball7">
          <img :src="imgUrl + iconList[0].logo_round" alt="" />
        </div>
      </div>
    </div>
    <div class="loppBox">
      <div id="lopp" class="lopp2">
        <div class="border"></div>
        <div class="ball ball8">
          <img :src="imgUrl + iconList[1].logo_round" alt="" />
        </div>
        <div class="ball ball8_2">
          <img :src="imgUrl + iconList[2].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX2 12s cubic-bezier(0.36, 0, 0.64, 1) -12s infinite alternate,animY2 12s cubic-bezier(0.36, 0, 0.64, 1) -6s infinite alternate',
        }">
          <img :src="imgUrl + iconList[3].logo_round" alt="" />
        </div>
      </div>
    </div>
    <div class="loppBox">
      <div id="lopp" class="lopp3">
        <div class="border"></div>
        <div class="ball ball9">
          <img :src="imgUrl + iconList[4].logo_round" alt="" />
        </div>
        <div class="ball ball9_2">
          <img :src="imgUrl + iconList[5].logo_round" alt="" />
        </div>
        <div class="ball ball9_3">
          <img :src="imgUrl + iconList[6].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -9s infinite alternate,animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -1s infinite alternate',
        }">
          <img :src="imgUrl + iconList[7].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -12s infinite alternate,animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -4s infinite alternate',
        }">
          <img :src="imgUrl + iconList[8].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -4s infinite alternate,animY3 16s cubic-bezier(0.36, 0, 0.64, 1) 4s infinite alternate',
        }">
          <img :src="imgUrl + iconList[9].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -7s infinite alternate,animY3 16s cubic-bezier(0.36, 0, 0.64, 1) 1s infinite alternate',
        }">
          <img :src="imgUrl + iconList[10].logo_round" alt="" />
        </div>
      </div>
    </div>
    <div class="loppBox">
      <div id="lopp" class="lopp4">
        <div class="border"></div>
        <div class="ball ball10">
          <img :src="imgUrl + iconList[11].logo_round" alt="" />
        </div>
        <div class="ball ball10_2">
          <img :src="imgUrl + iconList[12].logo_round" alt="" />
        </div>
        <div class="ball ball10_3">
          <img :src="imgUrl + iconList[13].logo_round" alt="" />
        </div>
        <div class="ball ball10_4">
          <img :src="imgUrl + iconList[14].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -51s infinite alternate,animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -41s infinite alternate',
        }">
          <img :src="imgUrl + iconList[15].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -61s infinite alternate,animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -51s infinite alternate',
        }">
          <img :src="imgUrl + iconList[16].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -76s infinite alternate,animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -66s infinite alternate',
        }">
          <img :src="imgUrl + iconList[17].logo_round" alt="" />
        </div>
        <div class="ball" :style="{
          animation:
            'animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -14s infinite alternate,animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -4s infinite alternate',
        }">
          <img :src="imgUrl + iconList[18].logo_round" alt="" />
        </div>
      </div>
    </div>
    <div class="textBox">
      <h2>{{ $tools.localStorageFn.get("PAGE_DATE").banner5_title }}</h2>
      <p v-html="$tools.localStorageFn.get('PAGE_DATE').banner5_content"></p>
      <button @click="$tools.blankPush('/cooperativePartner')">了解更多</button>
    </div> -->
    <!-- 底部提示 -->
    <div class="b_right_icon t_icon_backTop" @click="() => {
      $emit('move', 1);
    }
      "></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner5 +
          ") no-repeat center center",
      },

      iconList: [],
      iconOptions: [],
      title: ''
    };
  },
  created() {
    this.getIconList()
    this.getTitle(53)
    // this.$tools.localStorageFn.get("PAGE_DATE").partner.forEach((item) => {
    //   if (item.logo_round != null) {
    //     this.iconList.push(item)
    //   }
    // })
    // for (let i = this.iconList.length; i < 19; i++) {
    //   this.iconList.push({ id: i })
    // }
  },
  methods: {
    getIconList() {
      this.$axios
        .get(
          process.env.VUE_APP_API + "/api/v1/partners?page=" + this.curpage,
          {
            params: { per_page: 10 },
          }
        )
        .then((res) => {
          console.log("合作对象列表", res);
          if (res.status === 200) {
            this.iconOptions = res.data.data;
          } else {
            this.$message.error(res.statusText);
          }
        });
    },

    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.homePage06Box {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/homeBg06.png) no-repeat center center;
  background-size: cover !important;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding-top: 4.6rem;
  position: relative;
  overflow: hidden;


  .content {
    width: 135rem;

    .t_title {
      margin-bottom: 7.8rem;

      .t_titleText {
        font-size: 6.4rem;
        font-family: JingZhe_XiaoWei;
        font-weight: 400;
        color: #fff;
      }

      .t_titleBorder {
        width: 10rem;
        height: 0.3rem;
        background: #013060;
        margin: 1.2rem auto 1.6rem;
      }

      .t_titleEng {
        font-size: 2.4rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #013060;
        line-height: 2.4rem;
      }
    }


    .iconList {
      margin-top: 6.4rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .icon {
        height: 11.8rem;
        margin-bottom: 3.6rem;

        img {
          height: 100%;
        }
      }
    }

    .more {
      cursor: pointer;
      margin-top: 4.8rem;
      text-align: center;
      font-size: 2.2rem;
      color: #fff;
    }
  }

  .t_bar {
    z-index: 200;
    position: absolute !important;
    top: 6rem;
    left: 0;
    width: 100%;
    padding: 0.8rem;
    display: flex;
    justify-content: space-between;

    .t_logo {
      width: 20.5rem;
      height: 4.5rem;
    }

    .t_logo02 {
      background: url(~@/assets/images/logo02.png) no-repeat center center;
      background-size: cover;
    }

    .t_logo03 {
      background: url(~@/assets/images/logo03.png) no-repeat center center;
      background-size: cover;
    }

    .t_placeholder {
      height: 4.5rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        // margin-left: 3.4rem;
      }

      .t_menu {
        height: 2.6rem;
        margin: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5.7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_right {
      font-size: 2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 4.1rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        margin-left: 3.5rem;
      }

      .t_menu {
        height: 2.6rem;
        margin-left: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_blue {
      color: #013060 !important;
    }
  }

  .textBox {
    z-index: 20;
    text-align: center;

    h2 {
      font-size: 4rem;
      color: #fff;
      font-weight: normal;
    }

    p {
      width: 55rem;
      margin: 0;
      margin-bottom: 4.4rem;
      font-size: 1.5rem;
      color: #fff;
    }

    button {
      cursor: pointer;
      position: relative;
      margin-top: 3.8rem;
      width: 19.2rem;
      height: 4.7rem;
      background: url(~@/assets/images/icon_liaojiegengduo03.png) no-repeat center center;
      background-size: 100%;
      padding: 0;
      font-size: 1.6rem;
      font-family: SimHei;
      font-weight: 400;
      color: #fff;
      line-height: 4.7rem;
      transition: 0.6s;
      border: 0;
    }

    button:hover {
      color: #013060;
      background: url(~@/assets/images/icon_liaojiegengduo04.png) no-repeat center center;
      background-size: 100%;
    }

    .btn {
      margin: 0 auto;
      cursor: pointer;
      width: 15rem;
      height: 4.2rem;
      line-height: 4.2rem;
      text-align: center;
      border: 0.1rem solid #fff;
      color: #fff;
      font-size: 1.6rem;

    }
  }

  @keyframes animX {
    0% {
      margin-left: 0rem;
    }

    100% {
      margin-left: 40rem;
    }
  }

  @keyframes animY {
    0% {
      margin-top: 0rem;
    }

    100% {
      margin-top: 40rem;
    }
  }

  @keyframes animX2 {
    0% {
      margin-left: 0rem;
    }

    100% {
      margin-left: 60rem;
    }
  }

  @keyframes animY2 {
    0% {
      margin-top: 0rem;
    }

    100% {
      margin-top: 60rem;
    }
  }

  @keyframes animX3 {
    0% {
      margin-left: 0rem;
    }

    100% {
      margin-left: 85rem;
    }
  }

  @keyframes animY3 {
    0% {
      margin-top: 0rem;
    }

    100% {
      margin-top: 85rem;
    }
  }

  @keyframes animX4 {
    0% {
      margin-left: 0rem;
    }

    100% {
      margin-left: 120rem;
    }
  }

  @keyframes animY4 {
    0% {
      margin-top: 0rem;
    }

    100% {
      margin-top: 120rem;
    }
  }

  .ball {
    width: 10rem;
    height: 10rem;
    border-radius: 50%;
    position: absolute;
    font-size: 1.2rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ball7 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX 10s cubic-bezier(0.36, 0, 0.64, 1) -5s infinite alternate,
      animY 10s cubic-bezier(0.36, 0, 0.64, 1) 0s infinite alternate;
  }

  .ball8 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX2 12s cubic-bezier(0.36, 0, 0.64, 1) -9s infinite alternate,
      animY2 12s cubic-bezier(0.36, 0, 0.64, 1) -3s infinite alternate;
  }

  .ball8_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX2 12s cubic-bezier(0.36, 0, 0.64, 1) -19s infinite alternate,
      animY2 12s cubic-bezier(0.36, 0, 0.64, 1) -13s infinite alternate;
  }

  .ball9 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -26s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -18s infinite alternate;
  }

  .ball9_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -8s infinite alternate;
  }

  .ball9_3 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -36s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -28s infinite alternate;
  }

  .ball10 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -6s infinite alternate;
  }

  .ball10_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -26s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate;
  }

  .ball10_3 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -31s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -21s infinite alternate;
  }

  .ball10_4 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -46s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -36s infinite alternate;
  }

  .loppBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    #lopp {
      border-radius: 50%;
      position: relative;

      .border {
        position: absolute;
        border: 0.1rem dashed #fff;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .lopp1 {
      width: 50rem;
      height: 50rem;

      .border {
        width: 45rem;
        height: 45rem;
      }
    }

    .lopp2 {
      width: 70rem;
      height: 70rem;

      .border {
        width: 65rem;
        height: 65rem;
      }
    }

    .lopp3 {
      width: 90rem;
      height: 90rem;

      .border {
        width: 85rem;
        height: 85rem;
      }
    }

    .lopp4 {
      width: 130rem;
      height: 130rem;

      .border {
        width: 125rem;
        height: 125rem;
      }
    }
  }

  @media screen and (min-width: 1920px) {

    .content {
      width: 1400px;

      .t_title {
        margin-bottom: 78px;

        .t_titleText {
          font-size: 64px;
        }

        .t_titleBorder {
          width: 100px;
          height: 03px;
          margin: 12px auto 16px;
        }

        .t_titleEng {
          font-size: 24px;
          line-height: 24px;
        }
      }

      .iconList {
        margin-top: 64px;

        .icon {
          height: 118px;
          margin-bottom: 36px;

          img {
            height: 100%;
          }
        }
      }

      .more {
        margin-top: 48px;
        font-size: 22px;
      }
    }

    .t_bar {
      z-index: 200;
      position: absolute !important;
      top: 60px;
      left: 0;
      width: 100%;
      padding: 08px;
      display: flex;
      justify-content: space-between;

      .t_logo {
        width: 205px;
        height: 45px;
      }

      .t_logo02 {
        background: url(~@/assets/images/logo02.png) no-repeat center center;
        background-size: cover;
      }

      .t_logo03 {
        background: url(~@/assets/images/logo03.png) no-repeat center center;
        background-size: cover;
      }

      .t_placeholder {
        height: 45px;
        display: flex;
        align-items: center;

        span {
          cursor: pointer;
        }

        .t_icon {
          cursor: pointer;
          width: 28px;
          height: 28px;
          display: inline-block;
          // margin-left: 34px;
        }

        .t_menu {
          height: 26px;
          margin: 0 35px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .t_menuitem {
            width: 28px;
            height: 03px;
            background: #fff;
          }

          .t_menuitem2 {
            // margin: calc((100% - 57px) / 2) auto;
          }
        }

        .t_menu_blue {
          .t_menuitem {
            background: #013060;
          }
        }

        .t_menu:hover .t_menuitem2 {
          transform: translateX(-50%);
        }

        .t_icon_menu {
          background: url(~@/assets/images/icon_menu.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_menu02 {
          background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_search01 {
          background: url(~@/assets/images/icon_search01.png) no-repeat center center;
          background-size: 100% 100%;
        }

        .t_icon_search02 {
          background: url(~@/assets/images/icon_search02.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .t_right {
        font-size: 20px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #ffffff;
        line-height: 41px;
        display: flex;
        align-items: center;

        span {
          cursor: pointer;
        }

        .t_icon {
          cursor: pointer;
          width: 28px;
          height: 28px;
          display: inline-block;
          margin-left: 35px;
        }

        .t_menu {
          height: 26px;
          margin-left: 43px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .t_menuitem {
            width: 28px;
            height: 03px;
            background: #fff;
          }

          .t_menuitem2 {
            // margin: calc((100% - 5.7px) / 2) auto;
          }
        }

        .t_menu_blue {
          .t_menuitem {
            background: #013060;
          }
        }

        .t_menu:hover .t_menuitem2 {
          transform: translateX(-50%);
        }

        .t_icon_menu {
          background: url(~@/assets/images/icon_menu.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_menu02 {
          background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_search01 {
          background: url(~@/assets/images/icon_search01.png) no-repeat center center;
          background-size: 100% 100%;
        }

        .t_icon_search02 {
          background: url(~@/assets/images/icon_search02.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .t_blue {
        color: #013060 !important;
      }
    }

    .textBox {
      z-index: 20;
      text-align: center;

      h2 {
        font-size: 40px;
        color: #fff;
        font-weight: normal;
      }

      p {
        width: 450px;
        margin: 0;
        margin-bottom: 44px;
        font-size: 15px;
        color: #fff;
      }

      button {
        margin-top: 38px;
        width: 192px;
        height: 47px;
        font-size: 16px;
        line-height: 47px;
      }

      .btn {
        width: 150px;
        height: 42px;
        line-height: 42px;
        border: 1px solid #fff;
        font-size: 16px;

      }
    }
  }

  @keyframes animX {
    0% {
      margin-left: 0px;
    }

    100% {
      margin-left: 400px;
    }
  }

  @keyframes animY {
    0% {
      margin-top: 0px;
    }

    100% {
      margin-top: 400px;
    }
  }

  @keyframes animX2 {
    0% {
      margin-left: 0px;
    }

    100% {
      margin-left: 600px;
    }
  }

  @keyframes animY2 {
    0% {
      margin-top: 0px;
    }

    100% {
      margin-top: 600px;
    }
  }

  @keyframes animX3 {
    0% {
      margin-left: 0px;
    }

    100% {
      margin-left: 900px;
    }
  }

  @keyframes animY3 {
    0% {
      margin-top: 0px;
    }

    100% {
      margin-top: 900px;
    }
  }

  @keyframes animX4 {
    0% {
      margin-left: 0px;
    }

    100% {
      margin-left: 1300px;
    }
  }

  @keyframes animY4 {
    0% {
      margin-top: 0px;
    }

    100% {
      margin-top: 1300px;
    }
  }

  .ball {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    font-size: 12px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ball7 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX 10s cubic-bezier(0.36, 0, 0.64, 1) -5s infinite alternate,
      animY 10s cubic-bezier(0.36, 0, 0.64, 1) 0s infinite alternate;
  }

  .ball8 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX2 12s cubic-bezier(0.36, 0, 0.64, 1) -9s infinite alternate,
      animY2 12s cubic-bezier(0.36, 0, 0.64, 1) -3s infinite alternate;
  }

  .ball8_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX2 12s cubic-bezier(0.36, 0, 0.64, 1) -19s infinite alternate,
      animY2 12s cubic-bezier(0.36, 0, 0.64, 1) -13s infinite alternate;
  }

  .ball9 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -26s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -18s infinite alternate;
  }

  .ball9_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -8s infinite alternate;
  }

  .ball9_3 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX3 16s cubic-bezier(0.36, 0, 0.64, 1) -36s infinite alternate,
      animY3 16s cubic-bezier(0.36, 0, 0.64, 1) -28s infinite alternate;
  }

  .ball10 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -6s infinite alternate;
  }

  .ball10_2 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -26s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -16s infinite alternate;
  }

  .ball10_3 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -31s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -21s infinite alternate;
  }

  .ball10_4 {
    /*  在3 的基础上   顺时针 不从0 出来 */
    animation: animX4 20s cubic-bezier(0.36, 0, 0.64, 1) -46s infinite alternate,
      animY4 20s cubic-bezier(0.36, 0, 0.64, 1) -36s infinite alternate;
  }

  .loppBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    #lopp {
      border-radius: 50%;
      position: relative;

      .border {
        position: absolute;
        border: 1px dashed #fff;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .lopp1 {
      width: 500px;
      height: 500px;

      .border {
        width: 450px;
        height: 450px;
      }
    }

    .lopp2 {
      width: 700px;
      height: 700px;

      .border {
        width: 650px;
        height: 650px;
      }
    }

    .lopp3 {
      width: 950px;
      height: 950px;

      .border {
        width: 900px;
        height: 900px;
      }
    }

    .lopp4 {
      width: 1350px;
      height: 1350px;

      .border {
        width: 1300px;
        height: 1300px;
      }
    }
  }
}


.active {
  .homePage06Box {
    .t_title {
      animation-name: focus-in-contract-108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .iconList {
      animation-name: focus-in-contract108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .b_btn {
      animation-name: focus-in-contract108;
      animation-duration: 1s;
      animation-timing-function: ease-out;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .more {
      animation: fade-in-bottom96 3s ease 0s 1 normal none;
    }
  }
}
</style>